var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('back-button',{staticClass:"breadcrumb-item-padding"}),_c('b-breadcrumb',{staticClass:"d-inline-flex breadcrumb-item-padding breadcrumb-background-color",attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }